<div class="adapter-dialog">
  <div class="dialog-header">
    <div class="dialog-title-section">
      <div class="dialog-icon-container">
        <lucide-icon name="unplug" class="dialog-icon" [size]="20" [strokeWidth]="2"></lucide-icon>
      </div>
      <div class="dialog-title">
        {{ isEditMode ? 'Edit Adapter' : 'Add new adapter' }}
      </div>
    </div>
    <lucide-icon
      name="x"
      class="close-button"
      [size]="20"
      [strokeWidth]="2"
      (click)="onCancel()"
      [class.disabled]="isLoading"
    ></lucide-icon>
  </div>

  @if (errorMessage) {
    <div class="error-banner">
      <lucide-icon name="triangle-alert" [size]="20" [strokeWidth]="2"></lucide-icon>
      <span>{{ errorMessage }}</span>
    </div>
  }

  <form [formGroup]="adapterForm" class="dialog-content" [class.loading]="isLoading">
    <!-- Adapter Name -->
    <div class="form-field">
      <label class="required-label">Adapter name</label>
      <input matInput formControlName="name" placeholder="Enter adapter name" />
    </div>

    <!-- Platform Selection -->
    <div class="form-field">
      <label class="required-label">Select platform</label>
      <div class="platform-selection">
        @for (platform of platforms; track platform.id) {
          <div
            class="platform-card"
            [class.selected]="selectedPlatform === platform.id"
            [class.disabled]="platform.disabled"
            (click)="!platform.disabled && selectPlatform(platform.id)"
          >
            <div class="platform-icon-container">
              <div class="platform-icon">
                <img [src]="getPlatformLogo(platform.id)" [alt]="platform.name" />
              </div>
              <div class="platform-name">{{ platform.name }}</div>
              @if (selectedPlatform === platform.id) {
                <div class="selected-indicator">
                  <lucide-icon name="check" [size]="16" [strokeWidth]="2"></lucide-icon>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Dynamic Adapter Form Components -->
    @switch (selectedPlatform) {
      @case (AdapterPlatform.Splunk) {
        <app-splunk-adapter-form [isEditMode]="isEditMode"></app-splunk-adapter-form>
      }
      @case (AdapterPlatform.MicrosoftSentinel) {
        <app-sentinel-adapter-form [isEditMode]="isEditMode"></app-sentinel-adapter-form>
      }
    }
  </form>

  <div class="dialog-footer">
    <button mat-stroked-button (click)="onCancel()" [disabled]="isLoading" class="cancel-button">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!isFormValid"
      (click)="onCreate()"
      class="create-button"
      [class.loading]="isLoading"
    >
      @if (!isLoading) {
        {{ isEditMode ? 'Update' : 'Create' }}
      } @else {
        <mat-spinner diameter="16" strokeWidth="2"></mat-spinner>
      }
    </button>
  </div>
</div>
